import React from "react";
import SubjectTopics from "../subjectTopics"; // Import the SubjectTopics component

// Geometry Component
// This component renders a SubjectTopics component for the Geometry subject
const Geometry = () => <SubjectTopics subjectId={4} title="Geometry" />;

export default Geometry; // Export the Geometry component
